<template>
  <vue-custom-scrollbar class="scroll-area" :settings="scroll_settings">
    <div class="color_indicator"> 
      <h2>
        {{ $t("Cluster") }}
      </h2>
    </div>
    <div class="cluster-name-holder">
      <p id="main-titol">{{ cluster_seleccionat_store['ordered_id'] }}</p>
      <div style="width: 1em; height: 1em; border: 1px solid gray;" v-bind:style="{ 'background-color': cluster_seleccionat_store['color'] }"></div>
      <p id="main-titol" style="margin-left: 10px;">{{ cluster_seleccionat_store['cluster'] === 'undefined' ? $t('Non-clustered') : cluster_seleccionat_store['cluster'] }}</p>
    </div>
    <p>{{ $t("Number of documents") }}: {{ this.documents_cluster.length }}</p>
    
    <br/>

    <p id="titol">
      {{ $t("Relevant terms") }}:
    </p>
    <div style="margin-right: 10px; overflow-x: hidden; text-overflow: ellipsis;">
      <span v-for="(par, index) in this.paraules_destacades" v-bind:key="index" @click="$root.$emit('ToggleWordSearch',par)" style="cursor: pointer;">
        <div id="llista">{{ parWithComma(index) }}</div>
        {{ " " }}
      </span>
    </div>

    <br/>

    <p id="titol">
      {{ $t("Cluster stats") }}
    </p>
    <line-chart class="chart"></line-chart>

    <br/>

    <div v-if="cluster_seleccionat_store['cluster'] !== 'undefined' && this.related_clusters.length > 0">
      <div class="related-clust-heading">
        <p id="titol" style="grid-column: 1;">{{ $t("Related clusters") }}: </p>
        <p style="grid-column: 2; margin-top: 1em;">
          <input type="checkbox" v-model="$store.state.show_releated_clusters" @change="toggle_show_related_clusters" style="cursor: pointer"/>
          {{ $t("Show in graph") }}
        </p>
      </div>
      <div class="related-clust-content-wrap">
        <div class="related-clust-content-row" v-for="(entry, index) in this.related_clusters" v-bind:key="index">
          <div class="cluster-name-holder">
            <p style="justify-self: right;">{{ find_cluster_with_id(entry[0])['ordered_id'] }}</p>
            <div :style="'width: 1em; height: 1em; border: 1px solid gray; background-color: ' + find_cluster_with_id(entry[0])['color'] + ';'"></div>
            <p class="related-clust-content-title">{{entry[1]}}</p>
          </div>
          <p style="margin-right: 5px; justify-self: right; font-size: .7rem; text-align: right;">{{entry[2]}} {{entry[2] > 1 ? $t('edges') : $t('edge')}}</p>
        </div>
      </div>
      <br />
    </div>

    <p id="titol">
      {{ $t("Scopus Classification") }}
    </p>
    <bar-chart class="chart"> </bar-chart>
    
    <br />

    <div class="ordered-section-header">
      <p id="titol">
        {{ $t("Cluster authors") }} ({{this.ordered_authors.length}})
      </p>
      <div v-if="this.show_cluster_authors" class="drop-down">
        <button @click="drop_down_click" v-text="drop_down_selected_option_text"></button>
        <div class="drop-down-content" :style="author_order_drop_displayed ? 'display: block;' : 'display: none;' ">
          <p @click="drop_down_select($t('Alfabetically'), 'ABC')">{{ $t("Alfabetically") }}</p>
          <p @click="drop_down_select($t('% of publications in cluster'), 'PUBL')">{{ $t("% of publications in cluster") }}</p>
          <!-- 
          <p @click="drop_down_select('Avg. edges / publication', 'CSUBJ')">Avg. edges / publication</p>
          <p @click="drop_down_select('Distribution over years (x̄ ± σ)', 'TIME')">Distribution over years (x̄ ± σ)</p>
          <p @click="drop_down_select('# scopus covered', 'SCOPUS')"># scopus covered</p>
          <p @click="drop_down_select('Avg. co-authors / publication', 'COAUTH')">Avg. co-authors / publication</p>
          -->
        </div>
      </div>
    </div>
    <div class="info-scroll-wrapper">
      <button v-if="this.show_cluster_authors" class="order-btn" :title="$t('Reverse order')" @click="reverse_author_order">⇵</button>
      <vue-custom-scrollbar v-if="this.show_cluster_authors" class="info-scroll" :settings="scroll_settings">
        <span v-for="(author, index) in this.ordered_authors" v-bind:key="index" style="cursor: pointer;">
          <div id="llista" :style="index != 0 ? 'margin-top: 10px;' : '' " @click="$root.$emit('ToggleAuthorSearch', prev_drop_down_code == 'ABC' ? author : author.substr(0, author.indexOf('(')).trim())">{{ author }}</div><br />
          {{ " " }}
        </span>
        <br />
      </vue-custom-scrollbar>
      <button class="expand-btn" :title="this.show_cluster_authors?$t('Hide'):$t('Show')" @click="show_cluster_authors = !show_cluster_authors">{{this.show_cluster_authors?'▲':'▼'}}</button>
    </div>

    <br />

    <p id="titol" class="ordered-section-header" style="align-items: center;">
      {{ $t("Cluster publications") }} ({{this.documents_cluster.length}})
      <button v-if="this.show_cluster_publications" style="margin-left: auto; margin-right: 10px" :title="$t('Download list')" @click="download_publications_list">
        {{ $t("Download") }} ⇩</button>
    </p>
    <div class="info-scroll-wrapper">
      <vue-custom-scrollbar v-if="this.show_cluster_publications" class="info-scroll" :settings="scroll_settings">
        <span v-for="(node, index) in this.documents_cluster" v-bind:key="index" style="cursor: pointer;">
          <div id="llista" :style="index != 0 ? 'margin-top: 10px;' : '' " @click="select_node(node['id_node'])">{{ node['label'] }}</div><br />
          {{ " " }}
        </span>
        <br />
      </vue-custom-scrollbar>
      <button class="expand-btn" :title="this.show_cluster_publications?$t('Hide'):$t('Show')" @click="show_cluster_publications = !show_cluster_publications">{{this.show_cluster_publications?'▲':'▼'}}</button>
    </div>
    
    <br />

    <button @click="undisplay_info">{{ $t("Close") }}</button>

  </vue-custom-scrollbar>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import BarChart from "./BarChart.vue";
import LineChart from "./LineChart.vue";
export default {
  components: {
    vueCustomScrollbar,
    BarChart,
    LineChart,
  },
  name: "InfoCluster",
  props: ["api_url"],

  data() {
    return {
      drop_down_selected_option_text: this.$t('Alfabetically') + ' ⯆',
      prev_drop_down_code: 'ABC',
      ordered_authors: [],
      author_order_drop_displayed: false,
      author_descending: true,
      dades_scopus: [],
      paraules_destacades: [],
      documents_cluster: [],
      related_clusters: [],
      scroll_settings: {
        supressScrollX: true,
        minScrollbarLength: 50,
        maxScrollbarLength: 250,
        scrollXMarginOffset: 1000
      },
      show_cluster_authors: false,
      show_cluster_publications: false,
      last_calculated_clust_id: null
    };
  },

  computed: {
    cluster_seleccionat_store() {
      return this.$store.getters.clusters.find((e) => e['id'] === this.$store.getters.cluster_marcat);
    },
  },
  methods: {
    find_cluster_with_id: function(id) {
      return this.$store.getters.clusters.find((e) => e['id'] == id);
    },
    download_publications_list: function() {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.documents_cluster.map(e => e['label']).join('\n -------- \n')));
      element.setAttribute('download', 'ATLAS: Documents Cluster: '+ this.cluster_seleccionat_store['cluster']);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    undisplay_info: function() {
      this.$store.dispatch("Amaga_InfoCluster");
    },
    parWithComma(index) {
      if (index !== this.paraules_destacades.length - 1) {
        return `${this.paraules_destacades[index]},`;
      } else return this.paraules_destacades[index];
    },
    calcula_dades_cluster: async function() {
      let cluster = this.$store.getters.cluster_marcat;
      await this.get_paraules_destacades(cluster);
      await this.get_clusters_relacionats(cluster);
      await this.get_dades_scopus(cluster);
      this.carregaPieChart();
      await this.query_sorted_authors(cluster, this.prev_drop_down_code);
      await this.get_documents_cluster(cluster); 
    },
    get_paraules_destacades: function(num) {
      let url =
        this.$store.getters.api_url +
        "get_cluster_words?cluster=" +
        num;
      var self = this;
      this.paraules_destacades = [];
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            self.paraules_destacades = [];
            for (let i = 0; i < 10; ++i)
              self.paraules_destacades.push(response.data[i]);
            resolve(self.paraules_destacades);
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
    get_clusters_relacionats: function(num) {
      let related_cluster_dict_store = this.$store.getters.related_clusters_dict;
      if (num in related_cluster_dict_store) { 
        this.related_clusters = related_cluster_dict_store[num];
        return; 
      }
      let url =
        this.$store.getters.api_url +
        "/get_clusters_relacionats?cluster=" +
        num;
      this.related_clusters = [];
      var self = this;
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            self.related_clusters = response.data.filter(e=>e[2]>=4);
            self.$store.dispatch(
              "updateRelatedClusterEntry",
              {
                'id': num,
                'data': self.related_clusters
              }
            );
            resolve();
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
    get_dades_scopus: function(num) {
      let url =
        this.$store.getters.api_url +
        "/get_quesito?num=" +
        num;
      var self = this;
      this.dades_scopus = [];
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            self.dades_scopus = Object.keys(response.data);
            self.$store.dispatch(
              "actualitza_dades_bar_chart_cluster",
              Object.entries(response.data).sort((a, b) => b[1] - a[1])
            );
            resolve(self.dades_scopus);
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
    get_documents_cluster: function(num) {
      let url =
        this.$store.getters.api_url +
        "/get_documents_cluster?id=" +
        num;
      var self = this;
      this.documents_cluster = [];
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            self.documents_cluster = response.data;
            resolve(self.documents_cluster);
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
    carregaPieChart: function() {
      this.$root.$emit("BarChartCluster");
      this.$root.$emit("LineChart");
    },
    drop_down_click: function() {
      this.author_order_drop_displayed = !this.author_order_drop_displayed
      if (this.author_order_drop_displayed) {
        this.drop_down_selected_option_text = this.drop_down_selected_option_text.substring(0,this.drop_down_selected_option_text.length-1) + '⯅'
      } else {
        this.drop_down_selected_option_text = this.drop_down_selected_option_text.substring(0,this.drop_down_selected_option_text.length-1) + '⯆'
      }
    },
    drop_down_select: function(display_str, code) {
      this.author_order_drop_displayed = false;
      if (this.prev_drop_down_code != code) {
        this.drop_down_selected_option_text = display_str + ' ⯆';
        return this.query_sorted_authors(this.$store.getters.cluster_marcat, code);
      }
    },
    query_sorted_authors: function(cluster, code) {
      this.prev_drop_down_code = code;
      let url = this.$store.getters.api_url + "/get_cluster_authors?cluster=" + cluster + '&sort=' + code;
      var self = this;
      this.ordered_authors = [];
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            if (code == 'ABC') {
              self.ordered_authors = response.data;
            } /*else if (code == 'TIME') {
              self.ordered_authors = []
              for (let i = 0; i < response.data.length; i++) {
                let avg = new Date(Number(response.data[i][1])*1000);
                let new_entry = response.data[i][0] + '   (' + avg.toLocaleDateString("en-US", {month: 'short', year: 'numeric'});
                if (Number(response.data[i][2]) !== 0) {
                  let avg_plus_sd = new Date((Number(response.data[i][1])+Number(response.data[i][2]))*1000);
                  let sd = (avg_plus_sd.getFullYear() - avg.getFullYear()) + ((avg_plus_sd.getMonth() - avg.getMonth())/12);
                  new_entry = new_entry + ' ± ' + Number(sd.toFixed(2)) + ' years)'; 
                } else {
                  new_entry = new_entry + ')';
                }
                self.ordered_authors.push(new_entry);
              }
            }*/ else if (code == 'PUBL') {
              self.ordered_authors = response.data.map(function(e) {return e[0] + '   (' + Number(e[1].toFixed(2)) + '%)'});
            } else {
              // Ara que hem tret la resta això no s'hauria de cridar mai
              self.ordered_authors = response.data.map(function(e) {return e[0] + '   (' + Number(e[1].toFixed(2)) + ')'});
            }
            if (!self.author_descending) { self.ordered_authors = self.ordered_authors.reverse(); }
            resolve(self.ordered_authors);
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
    reverse_author_order: function() {  
      this.ordered_authors =  this.ordered_authors.reverse(); 
      this.author_descending = !this.author_descending; 
    },
    select_node: function(node) {
      this.$root.$emit("SearchSelectNode", node);
    },
    toggle_show_related_clusters: function() {
      this.$root.$emit("UpdateRelatedClusters");
    },
    actualitza_info_cluster_handler: function() {
      if (this.$store.getters.cluster_marcat !== this.last_calculated_clust_id) {
        this.last_calculated_clust_id = this.$store.getters.cluster_marcat;
        if (this.$store.getters.show_releated_clusters && this.$store.getters.cluster_marcat != 0) { //Si és el undefined, com no pinta els related tampoc cal esperar (per performance)
          this.calcula_dades_cluster().then(()=>{this.$root.$emit('ClusterInfoActualitzat');}); //Si no esperem a que acabi no s'actualitza bé la vista
        } else {
          this.calcula_dades_cluster();
          this.$root.$emit('ClusterInfoActualitzat'); // No cal que esperem, perquè el graf té la info necessària per pintar-se, no depèn de la crida per marcar els relacionats.
        }
      } else {
        this.$root.$emit('ClusterInfoActualitzat');
      }
    }
  },
  mounted() {
    this.actualitza_info_cluster_handler();
    this.$root.$on('ActualitzaInfoCluster', () => {
      this.actualitza_info_cluster_handler();
    });
  },
  beforeDestroy() {
    this.$root.$off('ActualitzaInfoCluster');
  }
};
</script>
<style>
p {
  font-size: 14px;
  font-family: Lato, sans-serif;
  color: #0077c8;
  line-height: 1.2;
  margin-bottom: 0.3em;
}
#titol {
  font-weight: bold;
  line-height: 0.9;
  margin-top: 1em;
  margin-right: 10px;
}
#main-titol {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.2;
  margin-right: 10px;
}
.cluster-name-holder {
  display: grid; 
  grid-template-columns: 1.1em min-content auto;
  grid-gap: 5px;
  align-items: center;
}
.cluster-name-holder #titol {
  margin: 0;
}

.info-scroll-wrapper {
  position: relative;
}
.info-scroll {
  position: relative;
  height: 40vh;
  overflow-y: hidden;
  padding: 10px 10px 0 10px;
  margin: 10px 20px 0 0;
  border-top: 1px solid #AAA;
}
.expand-btn {
  width: calc(100% - 20px);
  border: none;
  cursor: pointer;
  background: none;
  border-top: 1px solid #AAA;
  border-radius: 0 0 10px 10px;
}
.expand-btn:hover{
  background: #D5D5D5;
}
.order-btn {
  position: absolute;
  right: 5px;
  top: 5px;
  margin: 2px 22px 2px 2px;
  z-index: 1;
}
.ordered-section-header {
  display: flex;
  margin-right: 20px;
  position: relative;
}
.drop-down{
  margin-left: auto;
  align-self: flex-end;
  position: relative;
  z-index: 2;
}
.drop-down button{
  height: 80%;
  border: none;
  border-bottom: solid #AAA 1px;
  background: none;
  padding: 2px 10px;
  font-size: .85em;
  cursor: pointer;
}
.drop-down button:hover{
  background: #D5D5D5;
}
.drop-down-content {
  position: absolute;
  top: 100%;
  background-color: #f1f1f1;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  width: 100%;
}
.drop-down-content p {
  color: black;
  padding: 5px 16px;
  text-decoration: none;
  display: block;
  font-size: 0.75em;
  cursor: pointer;
}
.drop-down-content p:hover {
  background: #e5e5e5;
}
#llista {
  display: inline-block;
  font-size: 14px;
  font-family: Helvetica, Arial, sans-serif;
  color: #0077c8;
  line-height: 1.2;
  padding: 0em;
  margin-top: 0.2em;
  margin-bottom: 0em;
}
.chart {
  padding-top: 10px;
  margin-right: 10px;
}
.color_indicator {
  display: grid;
  grid-template-columns: max-content auto;
  grid-gap: 10px;
  align-items: center;
}
.related-clust-heading {
  display: grid;
  grid-template-columns: auto max-content;
  grid-gap: 10px;
  align-items: center;
  justify-content: left;
}
.related-clust-content-wrap {
  margin: 2px 12px 2px 0;
}
.related-clust-content-row {
  display: grid;
  grid-template-columns: 82% 18%;
  align-items: center;
  text-overflow: ellipsis;
}
.related-clust-content-title {
  overflow-x: hidden;
  text-overflow: ellipsis;
}
br {
  height: 10px;
}
</style>
